import React, { useContext, useEffect, useState } from "react";
import Layout from "../../Layout";
import { useStoreCRMConfig } from "../../../stores/useStoreCRMConfig";
import { useNavigate } from "react-router-dom";
import SharedDataContext from "../../../SharedDataContext";
import { useMutation } from "react-query";
import { getPlatformFields } from "../../../apis/workspace/integrations";
import { getCRMBulkRecords } from "../../../apis/workspace/general";
import useUpdateQueryParam from "../../../hooks/useUpdateQueryParam";
import { useQueryParams } from "../../../hooks/useQueryParams";
import { useStoreCRMSearch } from "../../../stores/useStoreCRMSearch";
import { crmBulkSearch } from "../../../apis/ext";
import TooltipWrapper from "../../TooltipWrapper";
import Image from "../../Tags/Image";
import EllipsisText from "../../EllipsisText";
import { Badge } from "../../ui/badge";
import { useStoreIntegrations } from "../../../stores/useStoreIntegrations";
import { Button } from "../../ui/button";
import { ChevronRightIcon, Copy, Trash2Icon } from "lucide-react";
import { useStoreCRMCreate } from "../../../stores/useStoreCRMCreate";
import { isUUIDKey } from "../../../utils/GenericFn";
import Input from "../../Tags/Input";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../ui/dropdown-menu";
import { CaretDownIcon } from "@radix-ui/react-icons";
import { useIntegrations } from "../../../apiHooks/useIntegrations";
import { useGetCRMSavedConfig } from "../../../apiHooks/useGetCRMSavedConfig";
import { useCRMCreateRecords } from "../../../apiHooks/useCRMCreateRecords";
import Text from "../../Tags/Text";
import AlertTag from "../../Alerts/Alert";
import { Alert, AlertTitle } from "../../ui/alert";
import TableLoader from "../../Loaders/TableLoader";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";

export default function CompanyListOfCrm() {
  const {
    savedCRMConfig,
    savedCompanyConfig,
    savedCompanyConfigWithWritePermission,
    savedCompanyConfigObj,
    savedPeopleConfig,
    savedPeopleConfigWithWritePermission,
  } = useStoreCRMConfig();

  const { crmBulkCreatePayload, crmBulkCreateData, getCRMCreateRecordById } = useStoreCRMCreate();

  const navigate = useNavigate();
  const userData = useContext(SharedDataContext);
  const { activeWorkspace } = userData || {};
  const crmConfigId =
    activeWorkspace?.preferences && activeWorkspace?.preferences?.active_crm_workspace_integration_config_id;
  const captureEvent = useCaptureEvent();

  const { refetch: refetchIntegrations } = useIntegrations(userData?.activeWorkspace?.id);

  const { setActiveCRMIntegrationById, installedCRMIntegrations, activeCRMIntegration } =
    useStoreIntegrations();
  const [bulkSearchPayload, setBulkSearchPayload] = useState([]);
  const [bulkRecordPayload, setBulkRecordPayload] = useState([]);
  const query = useQueryParams();
  const [enrichmentDetailsData, setEnrichmentDetailsData] = useState({});
  const [revealedContacts, setRevealedContacts] = useState([]);
  const [queryContacts, setQueryContacts] = useState([]);
  // const [searchParams, setSearchParams] = useSearchParams();
  const [payloadObject, setPayloadObject] = useState();
  const updateQueryParam = useUpdateQueryParam();

  const getSavedCRMConfigFn = useGetCRMSavedConfig(
    (data) => {
      console.log("CRM config saved:", data);
    },
    (error) => {
      console.error("CRM config failed:", error);
    }
  );

  useEffect(() => {
    if (crmConfigId && installedCRMIntegrations && installedCRMIntegrations.length > 0) {
      let activeCRMobj = installedCRMIntegrations.find((el) => `${el.id}` === `${crmConfigId}`);

      if (activeCRMobj) {
        setActiveCRMIntegrationById(activeCRMobj?.id);
        getSavedCRMConfigFn.mutate({
          crmKey: activeCRMobj?.integration?.key,
          crmConfigId: activeCRMobj?.id,
          options: {
            headers: { "X-Workspace-Id": userData?.activeWorkspace?.id },
          },
        });
      }
    }
  }, [crmConfigId, installedCRMIntegrations]);

  console.log("activeCRMIntegration", activeCRMIntegration);

  const getParams = () => {
    if (query?.payload && localStorage) {
      const obj = JSON.parse(localStorage.getItem(query?.payload));
      setPayloadObject(obj);

      let organizations = [];
      try {
        organizations = obj.organizations;

        // setQueryContacts(contacts);
        const payload = [];
        if (organizations && organizations.length > 0) {
          organizations.forEach((element) => {
            let el = {
              organization_id: element?.organization_id,
              crm_object_api_name: obj?.crm_object_api_name,
              type: "company",
              on_create: true,
            };

            payload.push(el);
          });
        }

        handleGetCRMBulkRecords(payload);
        setBulkRecordPayload(payload);
      } catch (e) {
        console.error("Invalid base64 contact list");
      }
    }
  };

  function updateLocalStorageObject(key, updates = {}) {
    try {
      const existing = JSON.parse(localStorage.getItem(key)) || {};
      const updated = { ...existing, ...updates };
      localStorage.setItem(key, JSON.stringify(updated));
      return updated;
    } catch (error) {
      console.error("Failed to update localStorage object:", error);
      return null;
    }
  }

  useEffect(() => {
    if (activeWorkspace && activeWorkspace.id) {
      setTimeout(() => {
        getParams();
      }, 300);
    }
  }, [query, activeWorkspace]);

  const {
    crmBulkSearchPayload,
    addChunkInCRMBulkSearchData,
    crmBulkSearchData,
    setCRMBulkSearchPayload,
    isCRMBulkSearchLoading,
    isCRMBulkSearchFetched,
    getCRMSearchRecordById,
    getCRMSearchRecordByIdFlat,
  } = useStoreCRMSearch();
  // bulk search
  const isCompanyInCRMFn = useMutation(
    ({ data, configId, options }) =>
      crmBulkSearch({
        data,
        configId,
        options,
        onStream: (chunk) => {
          console.log("📥 Streamed chunk:", chunk);

          addChunkInCRMBulkSearchData(chunk);
        },
      }),
    {
      onError(err) {
        console.error("❌ Bulk search stream error:", err);
      },
    }
  );

  const handleIsCompanyInCRM = (payload) => {
    if (isCompanyInCRMFn.isLoading) {
      return;
    }

    setCRMBulkSearchPayload(payload);

    isCompanyInCRMFn.mutate({
      data: payload,
      configId: crmConfigId,

      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  const [pushToCRMPayload, setPushToCRMPayload] = useState([]);
  const [searchFilter, setSearchFilter] = useState({});
  const [bulkRecordDataOrgWise, setBulkRecordDataOrgWise] = useState([]);
  const [bulkRecordData, setBulkRecordData] = useState([]);
  const [hasReferences, setHasReferences] = useState(false);
  const getCRMBulkRecordsFn = useMutation("get_bulk_record", getCRMBulkRecords, {
    onSuccess(data, variables, context) {
      console.log("data innnn", data);

      const obj = JSON.parse(localStorage.getItem(query?.payload));

      const paramsOrganizations = obj?.organizations;
      console.log("paramsOrganizations", paramsOrganizations);

      if (!paramsOrganizations) {
        return;
      }

      console.log("transformedPayload", paramsOrganizations);

      setPushToCRMPayload(paramsOrganizations);

      const bulkSearchPayloadCompany = [
        ...new Map(
          paramsOrganizations.map((el) => [
            el.organization_id,
            {
              organization_id: el.organization_id,
              type: "company",
              edit_search: false,
            },
          ])
        ).values(),
      ];

      console.log("bulkSearchPayloadCompany", bulkSearchPayloadCompany);

      const finalSearchPayload = [...bulkSearchPayloadCompany];
      setBulkSearchPayload(finalSearchPayload);

      console.log("bulkSearchPayload", finalSearchPayload);
      handleIsCompanyInCRM([...finalSearchPayload]);

      setBulkRecordData(data);

    },
    onError(error) {
      console.log(error);
    },
  });

  const handleGetCRMBulkRecords = (payload) => {
    getCRMBulkRecordsFn.mutate({
      data: payload,
      configId: crmConfigId,
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  // get getPlateformFields

  const [platformFieldsCompany, setPlatformFieldsCompany] = useState([]);
  const getPlatformFieldsFn = useMutation("get_platform_fields", getPlatformFields, {
    onSuccess(data, variables, context) {
      setPlatformFieldsCompany(data?.company);
    },
  });
  const handleGetPlatformFields = () => {
    getPlatformFieldsFn.mutate({
      type: "organizations",
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  useEffect(() => {
    if (activeWorkspace && activeWorkspace?.id) {
      handleGetPlatformFields();
    }
  }, [activeWorkspace]);

  function generateKeyLabelArray(inputObj) {
    if (!inputObj) {
      return;
    }

    return Object.keys(inputObj).map((outerKey) => {
      const fieldData = inputObj[outerKey];

      return {
        key: outerKey,
        label: fieldData?.label,
        required: fieldData?.required,
        is_custom: fieldData?.is_custom,
      };
    });
  }

  const getPrintableTableData = (systemFields, records) => {
    const obj = JSON.parse(localStorage.getItem(query?.payload));
    // const headers = systemFields.map((field) => ({
    //   key: field.key,
    //   label: field.label,
    // }));

    const headers = generateKeyLabelArray(records?.[0]?.data);

    const rows = records.map((record) => {
      const row = {};
      const fieldGroup = record.data;
      // 🧠 Go through each header key to extract data from new nested structure
      headers.forEach(({ key, label }) => {
        let found = false;
        if (fieldGroup && fieldGroup[key]) {
          row[key] = fieldGroup[key]?.value;
          found = true;
        }
        if (!found) {
          row[key] = ""; // fallback if key not found
        }

        if (isUUIDKey(key)) {
          setCustomFieldsObj((prev) => ({
            ...prev,
            [key]: records?.[0]?.data?.[key],
          }));
        }
      });

      row.record_id = record?.organization_id || "";

      const organizations = obj?.organizations || [];

      const foundOrganization = organizations.find((el) => el.organization_id === row.record_id);
      row.isRevealed = foundOrganization?.isRevealed;

      const crmRecords = getCRMSearchRecordByIdFlat(record?.organization_id);

      const crmRecordsWithError = getCRMCreateRecordById(record?.organization_id);

      console.log("crmRecordsWithError", { crmRecordsWithError, crmRecords });
      if (
        crmRecordsWithError &&
        crmRecordsWithError.crm_response_info &&
        crmRecordsWithError.crm_response_info.status !== 200
      ) {
        row.has_error = true;
        row.crm_response_info = crmRecordsWithError.crm_response_info;
      } else {
        row.has_error = false;
      }

      if (crmRecordsWithError && crmRecordsWithError.record_url) {
        row.record_url = crmRecordsWithError.record_url;
        row.record_exists = true;
      } else if (crmRecords && crmRecords.length > 0) {
        row.record_exists = true;
        row.record_url = crmRecords[0]?.record_url;
      } else {
        row.record_exists = false;
      }

      return row;
    });

    return { headers, rows };
  };

  const [customFieldsObj, setCustomFieldsObj] = useState({});
  const [tableHeads, setTableHeads] = useState([]);
  const [tableRows, setTableRows] = useState([]);
  const [tableRowsWithWithoutIsRevealed, setTableRowsWithWithoutIsRevealed] = useState([]);
  const [tableRowsWithIsRevealed, setTableRowsWithIsRevealed] = useState([]);
  const [tableRowsWithoutIsRevealed, setTableRowsWithoutIsRevealed] = useState([]);

  useEffect(() => {
    if (
      platformFieldsCompany &&
      platformFieldsCompany.length > 0 &&
      bulkRecordData &&
      bulkRecordData.length > 0
    ) {
      const { headers, rows } = getPrintableTableData(platformFieldsCompany, bulkRecordData);

      setTableHeads(headers);

      setTableRows(rows);
      setTableRowsWithWithoutIsRevealed(rows);
      setTableRowsWithIsRevealed(rows.filter((el) => el.isRevealed));
      setTableRowsWithoutIsRevealed(rows.filter((el) => !el.isRevealed));
    }
  }, [platformFieldsCompany, bulkRecordData, crmBulkSearchData]);

  console.log("tableRowsWithWithoutIsRevealed", tableRowsWithWithoutIsRevealed);

  useEffect(() => {
    // Send handshake to opener
    if (window.opener) {
      window.opener.postMessage("ready_for_payload");
    }

    // Listen for payload from parent
    window.addEventListener("message", (event) => {
      console.log("message in message", event);
      // if (event.origin !== "https://dev.primerole.com:3000") return;
      const { payloadKey, payload } = event.data;

      if (payloadKey && payload) {
        localStorage.setItem(payloadKey, JSON.stringify(payload));
        console.log("Payload stored in localStorage:", payloadKey);

        // Get all push_to_crm_payload_ keys except the current one
        const allPayloadKeys = Object.keys(localStorage).filter(
          (key) => key.startsWith("push_to_crm_payload_") && key !== payloadKey
        );

        // Parse timestamp from key
        const keyTimestampPairs = allPayloadKeys.map((key) => {
          const parts = key.split("push_to_crm_payload_");
          const timestamp = parseInt(parts[1], 10);
          return { key, timestamp: isNaN(timestamp) ? 0 : timestamp };
        });

        // Sort by timestamp descending (most recent first)
        keyTimestampPairs.sort((a, b) => b.timestamp - a.timestamp);

        // Keep most recent 4 (plus the current one makes 5 total)
        const keysToDelete = keyTimestampPairs.slice(4); // not 5 since current one is excluded

        keysToDelete.forEach(({ key }) => {
          localStorage.removeItem(key);
          console.log("Deleted old payload:", key);
        });
      }
    });
  }, []);

  function hasMissingRequiredFields(fieldsArray, recordObj) {
    return fieldsArray.some((field) => {
      const { key, required } = field;

      if (!required || recordObj.record_exists) return false;

      const value = recordObj[key];

      return value === null || value === undefined || value === "";
    });
  }
  // const [editedData, setEditedData] = useState({});
  const [editingCell, setEditingCell] = useState({ rowIndex: null, key: null });
  const handleCellEdit = (rowIndex, key, value) => {
    // PostHog: Track field edit
    captureEvent("ECRM_BulkCompanies_EditField", {
      field_key: key,
    });

    setTableRowsWithWithoutIsRevealed((prevRows) =>
      prevRows.map((row, idx) =>
        idx === rowIndex
          ? {
              ...row,
              input_fields: {
                ...(row.input_fields || {}),
                [key]: value,
              },
              [key]: value, // Optional: keep in sync for live display
            }
          : row
      )
    );
  };
  const copyCellValueToRows = (sourceRowIndex, key, copyTo = "empty") => {
    setTableRowsWithWithoutIsRevealed((prevRows) => {
      const sourceValue = prevRows[sourceRowIndex]?.[key] ?? prevRows[sourceRowIndex]?.input_fields?.[key];

      return prevRows.map((row, idx) => {
        if (idx === sourceRowIndex) return row; // skip source row

        const existingValue = row[key] ?? row?.input_fields?.[key];

        const shouldCopy = copyTo === "all" || (copyTo === "empty" && !existingValue);

        if (!shouldCopy) return row;

        return {
          ...row,
          input_fields: {
            ...(row.input_fields || {}),
            [key]: sourceValue,
          },
          [key]: sourceValue, // optional, for live display
        };
      });
    });
  };

  const getInitials = (name = "") => {
    if (!name) return "";

    const words = name.trim().split(/\s+/); // split by spaces
    if (words.length === 1) {
      return words[0][0].toUpperCase();
    }

    return (words[0][0] + words[1][0]).toUpperCase();
  };

  const { mutate: handleCRMCreate, isLoading: isCRMCreateLoading } = useCRMCreateRecords({
    onStream: (data, variables) => {
      console.log("crmRecords in create chunk push page", data);
      let chunk = JSON.parse(JSON.stringify(data));

      const obj = {
        search_filters_applied: {},
        records: null,
      };
      if (data.data && data.data.length > 0) {
        obj.records = data.data;

        // updateBulkRecordData(data?.contact_id || data?.person_id, data.data[0]);
        // if (data?.organization_id) {
        //   updateBulkRecordDataOrgWise(data?.organization_id, { name: data.data[0]?.name?.value });
        // } else {
        //   updateBulkRecordDataOrgWise(data?.contact_id || data?.person_id, data.data[0]);
        // }
      }

      if (data?.contact_id) obj.contact_id = data.contact_id;
      if (data?.person_id) obj.person_id = data.person_id;

      if (data?.person_id || data?.contact_id) {
        obj.crm_object_api_name = payloadObject.crm_object_api_name;
        obj.crm_object_label = payloadObject.crm_object_api_name;
        obj.type = "person";
      }

      if (data?.organization_id) {
        obj.organization_id = data.organization_id;
        obj.crm_object_api_name = payloadObject.crm_object_api_name_company;
        obj.crm_object_label = payloadObject.crm_object_api_name_company;
        obj.type = "company";
      }

      chunk.data = [obj];

      if (data?.crm_response_info?.status === 200) {
        addChunkInCRMBulkSearchData(chunk);
        // PostHog: Track create record success
        captureEvent("ECRM_BulkCompanies_CreateRecordsSuccess", {
          records_count: 1,
        });
      }
      if (data?.crm_response_info?.status !== 200) {
        addChunkInCRMBulkSearchData(chunk);
        // PostHog: Track create record failure
        captureEvent("ECRM_BulkCompanies_CreateRecordsFailure", {
          error_message: data?.crm_response_info?.error?.description || "Unknown error",
        });
        // toast.error(data?.crm_response_info?.error?.description);
      }
    },
    onError: (error) => {
      // PostHog: Track create records failure
      captureEvent("ECRM_BulkCompanies_CreateRecordsFailure", {
        error_message: error?.message || "Unknown error",
      });
    },
  });

  const handleCRMCreateFunction = (payload) => {
    handleCRMCreate({
      data: { requests: payload },
      configId: crmConfigId,
      options: {
        headers: {
          "X-Workspace-Id": activeWorkspace?.id,
          "Record-Source": process.env.REACT_APP_APP_NAME,
        },
      },
    });
  };

  const handleCreateBatchRecord = (data) => {
    if (
      isCRMCreateLoading ||
      (data && data.length === 0) ||
      (crmBulkCreateData && crmBulkCreateData.length < crmBulkCreatePayload && crmBulkCreatePayload.length)
    ) {
      return;
    }

    handleCRMCreateFunction(data);
  };

  const getCRMRecordPresenceStats = () => {
    let found = 0;
    let notFound = 0;
    if (tableRowsWithWithoutIsRevealed && tableRowsWithWithoutIsRevealed.length > 0) {
      tableRowsWithWithoutIsRevealed.forEach((company) => {
        const id = company?.record_id;
        const crmRecords = getCRMSearchRecordByIdFlat(id);

        if (crmRecords && crmRecords.length > 0) {
          found += 1;
        } else {
          notFound += 1;
        }
      });
    }

    return { found, notFound };
  };

  const renderCreateButton = () => {
    const nonExistingRecords = tableRowsWithWithoutIsRevealed.filter((el) => !el.record_exists) || [];

    let noNewRecords = nonExistingRecords?.length === 0;

    const validationErrors = getValidationErrors(tableRowsWithWithoutIsRevealed, tableHeads);
    const hasBlockingErrors = validationErrors.some((err) => err.validation_errors.length > 0);

    const isCreateButtonDisabled = hasBlockingErrors;

    const isDisabled = noNewRecords || isCreateButtonDisabled;

    const handleClick = () => {
      console.log("pushToCRMPayload", pushToCRMPayload);

      const filteredPayload = nonExistingRecords; // remove null entries

      console.log("pushToCRMPayload filteredPayload", filteredPayload);

      let transformed = filteredPayload.map((el) => {
        return {
          organization_id: el.record_id,
          crm_object_api_name: payloadObject?.crm_object_api_name,
          type: "company",
          ...(el.input_fields && { input_fields: el.input_fields }),
        };
      });
      console.log("pushToCRMPayload filteredPayload final", transformed);

      // PostHog: Track create records click
      captureEvent("ECRM_BulkCompanies_CreateRecordsClick", {
        records_count: getCRMRecordPresenceStats()?.notFound,
      });

      handleCreateBatchRecord(transformed);
    };

    return (
      <Button variant="purple-outline" type="button" onClick={handleClick} disabled={isDisabled}>
        {getCRMRecordPresenceStats()?.notFound > 0 ? (
          <>
            Create {getCRMRecordPresenceStats()?.notFound} Record
            {getCRMRecordPresenceStats()?.notFound > 1 ? "s" : ""}
          </>
        ) : (
          "Create Records"
        )}{" "}
        {isCRMCreateLoading && <div className="loader_circle ml-2"></div>}
      </Button>
    );
  };

  function getValidationErrors(dataArray, keysArray) {
    // Create a map for quick access to required keys and their labels
    const requiredKeyMap = keysArray
      .filter((field) => field.required)
      .reduce((acc, field) => {
        acc[field.key] = field.label;
        return acc;
      }, {});

    const errors = [];

    dataArray.forEach((org) => {
      let orgId = org?.record_id || org?.organization_id;
      const input = org.input_fields;
      const crmRecordsWithError = getCRMCreateRecordById(orgId);
      const crm_response_info = crmRecordsWithError?.crm_response_info || {};
      const orgData =
        bulkRecordData &&
        bulkRecordData.length > 0 &&
        bulkRecordData.find((el) => {
          return el?.organization_id === orgId;
        });

      if (org?.record_exists) {
        return;
      }

      const validation_errors = [];

      // ✅ Check for input field validation
      if (input && typeof input === "object") {
        for (const [key, value] of Object.entries(input)) {
          if (requiredKeyMap.hasOwnProperty(key) && (value === "" || value === null || value === undefined)) {
            validation_errors.push({
              key,
              label: requiredKeyMap[key],
              required: true,
            });
          }
        }
      }
      if ((!input || typeof input !== "object") && orgData?.data && typeof orgData.data === "object") {
        for (const key of Object.keys(requiredKeyMap)) {
          const field = orgData.data[key];
          const value = field?.value;

          if (value === "" || value === null || value === undefined) {
            validation_errors.push({
              key,
              label: requiredKeyMap[key],
              required: true,
            });
          }
        }
      }

      // ✅ If either validation errors OR crm_response_info has error
      if (validation_errors.length > 0 || crm_response_info.error) {
        errors.push({
          organization_id: orgId,
          validation_errors,
          ...(crm_response_info.error && { crm_response_info }), // Only add crm_response_info if error exists
          ignoreCrmResponseError: validation_errors.length === 0,
        });
      }
    });

    return errors;
  }

  function groupValidationErrorsByLabels(dataArray, keysArray) {
    const rawErrors = getValidationErrors(dataArray, keysArray);

    const groupMap = {};

    rawErrors.forEach((item) => {
      const labels = item.validation_errors?.map((e) => e.label).sort() || [];
      const crmError = item.crm_response_info?.error?.description || "";

      // Unique group key: labels + CRM error
      const groupKey = JSON.stringify({ labels, crmError });

      if (!groupMap[groupKey]) {
        groupMap[groupKey] = {
          labels,
          crmError,
          ids: [],
          count: 0,
        };
      }

      const id = item.record_id || item.organization_id;
      if (id) groupMap[groupKey].ids.push(id);
      groupMap[groupKey].count += 1;
    });

    return Object.values(groupMap);
  }

  const recordTypes = ["all_records", "action_required", "ready_to_add", "in_crm"];
  const [activeTypeOfRecord, setActiveTypeOfRecord] = useState("all_records");

  const isActiveTypeOfRecord = (type) => {
    return activeTypeOfRecord === type;
  };
  const getRecordType = (record) => {
    let recordType = "all_records";
    if (record.record_exists) {
      recordType = "in_crm";
    } else if (record.has_error) {
      recordType = "action_required";
    } else {
      recordType = "ready_to_add";
    }
    return recordType;
  };

  const switchToRecord = (type) => {
    setActiveTypeOfRecord(type);

    // PostHog: Track filter change
    captureEvent("ECRM_BulkCompanies_FilterChange", {
      filter_type: type,
    });

    // Select all rows with data-record-type
    const allRows = document.querySelectorAll("[data-record-type]");

    allRows.forEach((row) => {
      const rowType = row.getAttribute("data-record-type");

      // Show the row if it matches current type or it's "all_records"
      if (type === "all_records" || rowType === type) {
        row.classList.remove("record__validation__row__hidden");
      } else {
        row.classList.add("record__validation__row__hidden");
      }
    });
    const containers = document.querySelectorAll(".records__row__container");

    containers.forEach((container) => {
      const allRowsInContainer = container.querySelectorAll(".record__validation__row");
      const hiddenRowsInContainer = container.querySelectorAll(
        ".record__validation__row.record__validation__row__hidden"
      );

      if (allRowsInContainer.length === hiddenRowsInContainer.length) {
        container.classList.add("records__row__container__hidden");
      } else {
        container.classList.remove("records__row__container__hidden");
      }
    });
  };

  const removeOrgFromLocalStorageByRecord = (recordId) => {
    if (!recordId) return;

    const payloadStr = localStorage.getItem(query?.payload);
    console.log("payloadStr", payloadStr);
    if (!payloadStr) return;

    try {
      const payload = JSON.parse(payloadStr);

      if (Array.isArray(payload.organizations)) {
        payload.organizations = payload.organizations.filter((org) => org.organization_id !== recordId);

        localStorage.setItem(query?.payload, JSON.stringify(payload));
        console.log(`Removed record_id ${recordId} from ${query?.payload}`);
      }
    } catch (err) {
      console.error("Failed to parse localStorage payload:", err);
    }
  };

  if (isCRMBulkSearchLoading || getCRMBulkRecordsFn.isLoading) {
    return (
      <Layout>
        <div className="flex justify-center w-full h-[80vh] items-center">
          <div className="m-10">
            <div className="flex items-center space-x-3">
              {activeCRMIntegration?.integration?.key && (
                <Image src={`/images/crm/${activeCRMIntegration?.integration?.key}.svg`} className="w-14" />
              )}
              <Text size="lg">Processing. Do not close this page...</Text>
            </div>
            <div className="flex items-center space-x-10">
              <ul role="list" className="my-9 space-y-6">
                <li>
                  <div className="relative pb-3">
                    <span
                      className="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200"
                      aria-hidden="true"
                    ></span>
                    <div className="relative">
                      <div className="flex space-x-3 items-start">
                        <span className="h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center">
                          <ChevronRightIcon />
                        </span>
                        <div className="">
                          <div className="">
                            <span className="text-[16px] text-gray-500 font-semibold block mb-2">
                              Search for existing records in CRM
                            </span>
                            <Button
                              variant="outline"
                              className="rounded-md bg-white h-9 pointer-events-none space-x-3 w-auto"
                            >
                              {(getCRMBulkRecordsFn.isLoading ||
                                isCRMBulkSearchLoading ||
                                !isCRMBulkSearchFetched) && (
                                <>
                                  <div className="loader_circle"></div>
                                  <span>Searching...</span>
                                </>
                              )}
                              {isCRMBulkSearchFetched &&
                                !isCRMBulkSearchLoading &&
                                !getCRMBulkRecordsFn.isLoading && (
                                  <>
                                    <Image src={`/images/ext/check-green.svg`} />
                                    <span>Done</span>
                                  </>
                                )}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <div>
                <Image src={`/images/gym.svg`} />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <Text size="lg">Review companies to add to CRM</Text>
          <Text size="p" className="mt-1">
            Please review the the following records. The records will be created as{" "}
            {
              savedCompanyConfig?.find((el) => payloadObject?.crm_object_api_name === el?.crm_object_api_name)
                ?.crm_object_label
            }
            {"s "}
            in the CRM
          </Text>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">{renderCreateButton()}</div>
      </div>
      {!savedCompanyConfigWithWritePermission?.length && (
        <div className="mt-5">
          <AlertTag
            icon="/images/icons/untitledui/alert-warning.svg"
            variant="warning"
            heading={"Permissions denied"}
            description={`You don’t have access to create or update Company and Person records. Click Manage Permissions to set the required access.`}
            dismiss={false}
            cta={
              <>
                <a
                  target="_blank"
                  href={`${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_APP_HOME}/${activeWorkspace?.slug}/settings/integrations/${activeCRMIntegration?.integration?.key}/${activeCRMIntegration?.id}/`}
                  asChild
                >
                  <Button>Manage Permissions</Button>
                </a>
              </>
            }
          />
        </div>
      )}

      {getCRMRecordPresenceStats()?.notFound === 0 && getCRMRecordPresenceStats()?.found > 0 && (
        <Alert className="mt-3" variant={"success"}>
          <div className="flex items-start space-x-3">
            <Image
              src={"/images/icons/untitledui/alert-success.svg"}
              width="30"
              height="30"
              className="no-invert inline-block -mt-1 -ml-1"
            />
            <div>
              <AlertTitle className="text-gray-900 font-bold mb-2">
                All records have been pushed to CRM or already exist
              </AlertTitle>

              <div className="">No action required. You can safely close this page.</div>
            </div>
          </div>
        </Alert>
      )}

      {getValidationErrors(tableRowsWithWithoutIsRevealed, tableHeads) &&
        getValidationErrors(tableRowsWithWithoutIsRevealed, tableHeads).length > 0 && (
          <>
            <Alert className="mt-3" variant={"warning"}>
              <div className="flex items-start space-x-3">
                <Image
                  src={"/images/icons/untitledui/alert-warning.svg"}
                  width="30"
                  height="30"
                  className="no-invert inline-block -mt-1 -ml-1"
                />
                <div>
                  <AlertTitle className="text-gray-900 font-bold mb-2">
                    There are some issues with mentioned records.
                  </AlertTitle>

                  {groupValidationErrorsByLabels(tableRowsWithWithoutIsRevealed, tableHeads).map(
                    (group, idx) => (
                      <div key={idx} className="mt-3">
                        <span
                          className="text-brand-800 font-bold cursor-pointer"
                          onClick={() => {
                            const tr = document.getElementById(group?.ids?.[0]);
                            if (tr) {
                              tr.scrollIntoView({ behavior: "smooth", block: "center" });
                              tr.classList.add("outline", "outline-warning-600");
                              setTimeout(() => tr.classList.remove("outline", "outline-warning-600"), 2000);
                            }
                            captureEvent("ECRM_BulkCompanies_ClickToFix", {
                              error_labels: group.labels,
                              records_count: group.count,
                            });
                          }}
                        >
                          Click here to fix
                        </span>{" "}
                        {group.crmError && (
                          <>
                            <TooltipWrapper content={group.crmError} contentClassName="w-[400px]">
                              <b className="font-bold text-foreground">[ERROR]</b>
                            </TooltipWrapper>
                            {group.labels.length > 0 && <span className="mx-2">&</span>}
                          </>
                        )}
                        {group.labels.length > 0 && (
                          <span className="font-bold text-foreground">
                            [
                            <>
                              {group.labels.map((label, index) => (
                                <TooltipWrapper key={label} content="Field is required.">
                                  <span className="font-bold text-foreground">
                                    "{label}"{index !== group.labels.length - 1 && ", "}
                                  </span>
                                </TooltipWrapper>
                              ))}
                            </>
                            ]
                          </span>
                        )}{" "}
                        in <b>{group.count}</b> record{group.count > 1 ? "s" : ""}
                      </div>
                    )
                  )}
                </div>
              </div>
            </Alert>
          </>
        )}

      {(getCRMRecordPresenceStats()?.found > 0 || getCRMRecordPresenceStats()?.notFound > 0) && (
        <div className="inline-flex items-center mt-3">
          <div className="inline-flex rounded-md border bg-gray-iron-50 overflow-hidden p-1.5">
            <span
              onClick={() => {
                switchToRecord("all_records");
                captureEvent("ECRM_BulkCompanies_SwitchRecordView", {
                  view: "all_records",
                });
              }}
              className={`${isActiveTypeOfRecord("all_records") ? "bg-white rounded-md text-foreground border" : "cursor-pointer text-gray-600"} py-2 font-bold px-4  inline-flex items-center space-x-2`}
            >
              <span>All Records</span>{" "}
              <Badge>{getCRMRecordPresenceStats()?.found + getCRMRecordPresenceStats()?.notFound}</Badge>
            </span>

            {getCRMRecordPresenceStats()?.notFound > 0 && (
              <>
                {getValidationErrors(tableRowsWithWithoutIsRevealed, tableHeads) &&
                  getValidationErrors(tableRowsWithWithoutIsRevealed, tableHeads).length > 0 && (
                    <span
                      onClick={() => {
                        switchToRecord("action_required");
                        captureEvent("ECRM_BulkCompanies_SwitchRecordView", {
                          view: "action_required",
                        });
                      }}
                      className={`${isActiveTypeOfRecord("action_required") ? "bg-white rounded-md text-foreground border" : "cursor-pointer text-gray-600"} py-2 font-bold px-4  inline-flex items-center space-x-2`}
                    >
                      <Image src={`/images/ext/crm/error.svg`} className="" />
                      <span>
                        Action Required
                        {/* {getCRMRecordPresenceStats()?.notFound} record
                                {getCRMRecordPresenceStats()?.notFound > 1 ? "s" : ""} will be sent to CRM */}
                      </span>
                      {/* <Image
                                src={`/images/crm/${activeCRMIntegration?.integration?.key}-blue.svg`}
                                className="h-4"
                              /> */}
                      <Badge>{getValidationErrors(tableRowsWithWithoutIsRevealed, tableHeads).length}</Badge>
                    </span>
                  )}
                {getCRMRecordPresenceStats()?.notFound -
                  getValidationErrors(tableRowsWithWithoutIsRevealed, tableHeads).length >
                  0 && (
                  <span
                    onClick={() => {
                      switchToRecord("ready_to_add");
                      captureEvent("ECRM_BulkCompanies_SwitchRecordView", {
                        view: "ready_to_add",
                      });
                    }}
                    className={`${isActiveTypeOfRecord("ready_to_add") ? "bg-white rounded-md text-foreground border" : "cursor-pointer text-gray-600"} py-2 font-bold px-4  inline-flex items-center space-x-2`}
                  >
                    <span>
                      Ready to add
                      {/* {getCRMRecordPresenceStats()?.notFound} record
                                {getCRMRecordPresenceStats()?.notFound > 1 ? "s" : ""} will be sent to CRM */}
                    </span>
                    {/* <Image
                                src={`/images/crm/${activeCRMIntegration?.integration?.key}-blue.svg`}
                                className="h-4"
                              /> */}
                    <Badge>
                      {getCRMRecordPresenceStats()?.notFound -
                        getValidationErrors(tableRowsWithWithoutIsRevealed, tableHeads).length}
                    </Badge>
                  </span>
                )}
              </>
            )}
            {getCRMRecordPresenceStats()?.found > 0 && (
              <>
                <span
                  onClick={() => {
                    switchToRecord("in_crm");
                    captureEvent("ECRM_BulkCompanies_SwitchRecordView", {
                      view: "in_crm",
                    });
                  }}
                  className={`${isActiveTypeOfRecord("in_crm") ? "bg-white rounded-md text-foreground border" : "cursor-pointer text-gray-600"} py-2 font-bold px-4  inline-flex items-center space-x-2`}
                >
                  <Image
                    src={`/images/crm/${activeCRMIntegration?.integration?.key}-blue.svg`}
                    className="h-4"
                  />
                  <span>
                    {/* {getCRMRecordPresenceStats()?.found} record
                                  {getCRMRecordPresenceStats()?.found > 1 ? "s" : ""} found */}
                    In CRM
                  </span>{" "}
                  {/* <Image src="/images/ext/crm/matched.svg" /> */}
                  {/* <Image
                                  src={`/images/crm/${activeCRMIntegration?.integration?.key}-blue.svg`}
                                  className="h-4"
                                /> */}
                  <Badge>{getCRMRecordPresenceStats()?.found}</Badge>
                </span>
              </>
            )}
          </div>
        </div>
      )}

      {getCRMBulkRecordsFn.isLoading && <TableLoader />}

      {(getCRMRecordPresenceStats()?.found > 0 || getCRMRecordPresenceStats()?.notFound > 0) && (
        <div
          className={`mt-5 border border-gray-300 rounded-md records__row__container ${tableRowsWithWithoutIsRevealed && tableRowsWithWithoutIsRevealed.length === 0 && "hidden"}`}
        >
          <div className=" overflow-x-auto">
            <table className="w-full border-collapse text-sm text-left">
              <thead className="bg-gray-100 text-gray-700 font-semibold">
                <tr>
                  <th className="px-4 py-2 border-b border-gray-300 border-r border-gray-200 whitespace-pre sticky left-0 z-10 bg-gray-100 shadow-right ">
                    <span className="w-[450px] inline-block">Name</span>
                  </th>
                  {tableHeads &&
                    tableHeads.length > 0 &&
                    tableHeads.map((th) => (
                      <th className="px-4 py-2 border-b border-gray-300 border-r border-gray-200 whitespace-pre">
                        {th?.label} {th?.required && <span className="text-red-500">*</span>}
                      </th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {tableRowsWithWithoutIsRevealed &&
                  tableRowsWithWithoutIsRevealed.length > 0 &&
                  tableRowsWithWithoutIsRevealed.map((item, index) => (
                    <tr
                      data-record-type={getRecordType({
                        record_exists: item.record_exists,
                        has_error: (item && item.has_error) || hasMissingRequiredFields(tableHeads, item),
                      })}
                      className={`record__validation__row ${item && item.has_error ? "bg-red-50 " : ""}`}
                      id={item?.record_id}
                    >
                      <td
                        className={`px-4 py-2 border-b border-r   ${(item && item.has_error) || hasMissingRequiredFields(tableHeads, item) ? "border-red-200 bg-red-100" : "border-gray-200 bg-white"} sticky left-0 z-10  shadow-right`}
                      >
                        <div className="flex items-center whitespace-pre justify-between space-x-4 w-[450px]">
                          <div className="inline-flex items-center">
                            {((item && item.has_error) || hasMissingRequiredFields(tableHeads, item)) && (
                              <TooltipWrapper
                                content={
                                  hasMissingRequiredFields(tableHeads, item)
                                    ? "There is some issue with this record"
                                    : item?.crm_response_info?.error?.description
                                }
                                className="w-[20px] min-w-[20px] h-[20px] mr-3"
                              >
                                <Image src={`/images/ext/crm/error.svg`} className="" />
                              </TooltipWrapper>
                            )}

                            <div className="h-9 w-9 flex-shrink-0 items-center bg-gray-100 border border-border justify-center inline-flex rounded-full text-xs">
                              {item?.name && getInitials(item?.name)}
                            </div>
                            <div className="ml-4 pr-4">
                              <div className="font-bold text-gray-800 inline-flex items-center">
                                <span>
                                  <EllipsisText
                                    charLimit={24}
                                  >{`${item?.name ? item?.name : ""}`}</EllipsisText>
                                </span>{" "}
                                <Badge variant="gray" className="ml-2">
                                  {payloadObject?.crm_object_api_name}
                                </Badge>
                                {item?.record_url && (
                                  <a href={item?.record_url} target="_blank" className="w-6 h-6 inline-block">
                                    <Image src="/images/ext/crm/hyperlink.svg" />
                                  </a>
                                )}
                              </div>
                            </div>
                          </div>
                          {item.record_exists && (
                            <span className="w-14 inline-flex items-center justify-between">
                              <Image
                                src={`/images/crm/${activeCRMIntegration?.integration?.key}-blue.svg`}
                                className="h-4"
                              />
                              <Image src={`/images/ext/crm/matched.svg`} className="ml-2" />
                            </span>
                          )}
                          {tableRowsWithWithoutIsRevealed.length > 1 && !item.record_exists && (
                            <Button
                              variant="danger-outline"
                              onClick={() => {
                                // PostHog: Track delete record
                                captureEvent("ECRM_BulkCompanies_DeleteRecord", {
                                  organization_id: item?.record_id,
                                });
                                setTableRowsWithWithoutIsRevealed((prev) =>
                                  prev.filter((el) => el.record_id !== item?.record_id)
                                );
                                // removePersonFromPayload(item?.record_id);
                                removeOrgFromLocalStorageByRecord(item?.record_id);
                              }}
                            >
                              <Trash2Icon width={16} height={16} />
                            </Button>
                          )}
                        </div>
                      </td>
                      {tableHeads &&
                        tableHeads.length > 0 &&
                        tableHeads.map((th) => (
                          <td
                            className={`px-4 py-2 border-b border-r  ${((item && item.has_error) || (!item[th.key] && th.required)) && !item.record_exists ? "border-red-200 bg-red-100" : "border-gray-200 bg-white"}`}
                            onClick={() => setEditingCell({ rowIndex: index, key: th.key })}
                          >
                            <div className="inline-flex items-center space-x-2 w-full">
                              <div className="flex-1">
                                {editingCell.rowIndex === index &&
                                editingCell.key === th.key &&
                                !item.record_exists ? (
                                  <>
                                    {customFieldsObj[th.key] &&
                                    customFieldsObj[th.key].picklist_values &&
                                    customFieldsObj[th.key].picklist_values.length > 0 ? (
                                      <select
                                        name={th.key}
                                        className="rounded-[8px] w-full bg-white border border-[#dddddd] text-[#11181C] text-[14px] p-2 h-10 min-w-[150px]"
                                        onChange={(e) => handleCellEdit(index, th.key, e.target.value)}
                                        onBlur={() => setEditingCell({ rowIndex: null, key: null })}
                                        value={item[th.key] ?? ""}
                                      >
                                        <option value="">--Select--</option>
                                        {customFieldsObj[th.key].picklist_values.map((el) => (
                                          <option key={el} value={el}>
                                            {el}
                                          </option>
                                        ))}
                                      </select>
                                    ) : (
                                      <Input
                                        className="min-w-[150px] w-full"
                                        autoFocus
                                        value={item[th.key] ?? ""}
                                        onBlur={() => setEditingCell({ rowIndex: null, key: null })}
                                        onChange={(e) => handleCellEdit(index, th.key, e.target.value)}
                                        onKeyDown={(e) => {
                                          if (e.key === "Enter")
                                            setEditingCell({ rowIndex: null, key: null });
                                        }}
                                      />
                                    )}
                                  </>
                                ) : (
                                  <TooltipWrapper content={!item.record_exists && "Click to edit"}>
                                    <span className="inline-block border border-transparent whitespace-pre ">
                                      <EllipsisText
                                        tooltipContentClasses="w-[300px] whitespace-normal"
                                        charLimit={80}
                                      >
                                        {item[th?.key] || "-"}
                                      </EllipsisText>
                                    </span>
                                  </TooltipWrapper>
                                )}
                              </div>

                              {isUUIDKey(th.key) && item[th.key] && !item.record_exists && (
                                <DropdownMenu>
                                  <DropdownMenuTrigger asChild>
                                    <button
                                      type="button"
                                      className="ml-2 inline-flex items-center space-x-1 focus:outline-none rounded border border-gray-300 py-1.5 px-2.5"
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      <Copy width={16} height={16} />
                                      <CaretDownIcon width={16} height={16} />
                                    </button>
                                  </DropdownMenuTrigger>

                                  <DropdownMenuContent className="w-full mt-1.5 ml-3 z-50" align="end">
                                    <DropdownMenuGroup>
                                      <DropdownMenuItem
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setEditingCell({ rowIndex: null, key: null });
                                          copyCellValueToRows(index, th.key, "empty");
                                        }}
                                      >
                                        <Copy width={16} height={16} className="mr-2" />
                                        Copy to empty rows
                                      </DropdownMenuItem>
                                      <DropdownMenuItem
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setEditingCell({ rowIndex: null, key: null });
                                          copyCellValueToRows(index, th.key, "all");
                                        }}
                                      >
                                        <Copy width={16} height={16} className="mr-2" />
                                        Copy to all rows
                                      </DropdownMenuItem>
                                    </DropdownMenuGroup>
                                  </DropdownMenuContent>
                                </DropdownMenu>
                              )}
                            </div>
                          </td>
                        ))}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <div className="sm:flex sm:items-center mt-6">
        <div className="sm:flex-auto"></div>
        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none space-x-2">{renderCreateButton()}</div>
      </div>
    </Layout>
  );
}
